// extracted by mini-css-extract-plugin
module.exports = {"Grid":"Layout_Grid__2_ljo","OuterMargins":"Layout_OuterMargins__2psmE"};